import React from 'react';

import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';

interface SectionTitleProps extends TypographyProps {
  first?: string;
  second?: string;
  third?: string;
  type?: TypeValue;
  variant?: VariantValue;
  padding?: string;
}

type TypeValue = 'titles' | 'subtitles' | 'menu' | 'pageLink';
type VariantValue = 'subtitle1' | 'h6' | 'body1';

const SectionTitle: React.FC<SectionTitleProps> = ({
  first,
  second,
  third,
  type = 'subtitles',
  variant = 'subtitle1',
  padding = '20',
  ...props
}) => {
  return (
    <Typography
      className={`neuropol ${type === 'menu' || type === 'pageLink' ? 'uppercase ' : ''}${type}`}
      variant={`${variant}`}
      component={type === 'titles' || type === 'subtitles' ? 'h2' : 'span'}
      sx={{
        paddingTop: `${padding}px`,
      }}
      {...props}
    >
      {first && <span className='blue'>{first}</span>}
      {first && second ? ' ' : null}
      {second && <span className='grey'>{second}</span>}
      {third && (first || second) ? ' ' : null}
      {third && <span className='black'>{third}</span>}
    </Typography>
  );
};

export default SectionTitle;
